import http from '@yld/yun-utils-http'
import { BASE_URL } from '@yld/yun-utils-host'

const api_30004 = BASE_URL.WG + '/api/30004'

// 获取预警推送设置
export function searchEarlyWarningPush() {
  return http.post(api_30004 + '/order/exception/getOrderEarlyWarningPush')
}

// 保存预警推送设置
export function saveOrderEarlyWarningPush(data) {
  return http.post(api_30004 + '/order/exception/saveOrderEarlyWarningPush', data)
}

// 获取预警推送
export function getOrderEarlyWarningPush() {
  return http.post(api_30004 + '/orderEarlyWarningPush/getOrderEarlyWarningPush')
}

// 保存预警推送
export function saveOrderEarlyWarningPushNew(data) {
  return http.post(api_30004 + '/orderEarlyWarningPush/saveOrderEarlyWarningPush', data)
}